/**
 * Fallback component for code splitting.
 * Until split chunks get loaded this component will be shown.
 */
const Fallback = props => {
  return <div style={{ height: "100vh" }}></div>;
};
export default Fallback;
